export default __webpack_public_path__ + "static/media/usage.0120eeb9.svg";